// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JwlZ","top":"styles_top__3VnzU"};